import GavelIcon from '@mui/icons-material/Gavel';
import LoginIcon from '@mui/icons-material/Login';
import { Box, Button, Container, Fab, Paper, Typography } from '@mui/material';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom";
import './App.css';
import Footer from './Footer';
import './Home.css';
import LawAppBar from './LawAppBar';

export default function Home() {
    const [cookies] = useCookies(['given_name', 'userid', 'picture', 'email', 'credential']);

    const navigate = useNavigate();

    return (
        <div className="App">
            <LawAppBar cookies={cookies} />
            <Container sx={{
                width: "100%",
                maxWidth: "100%",
                padding: "0 20px"
            }}>
                <Box my={2.5} className="welcome-section">
                    <Typography
                        variant="h4"
                        component="h1"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 400,
                            fontSize: '2.4rem',
                            marginBottom: '0.8rem',
                            letterSpacing: '-0.02em'
                        }}
                    >
                        AI Assistant for Personal Injury Law
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        gutterBottom
                        sx={{
                            color: "var(--text-secondary)",
                            fontSize: "1.1rem",
                            fontWeight: 400,
                            lineHeight: 1.5,
                            maxWidth: 900,
                            margin: "0 auto 1.5rem auto"
                        }}
                    >
                        Upload medical records, medical bills, police reports, and other case documents to generate detailed medical chronologies, tabulate medical expenses, draft documents, and receive comprehensive document summaries and categorization.
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        gap: 2,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexWrap: 'wrap'
                    }}>
                        <Fab
                            variant="extended"
                            size="large"
                            color="primary"
                            onClick={() => navigate('/mycases')}
                            sx={{
                                background: 'var(--button-gradient)',
                                boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)',
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: '1.05rem',
                                padding: '15px 28px',
                                borderRadius: '16px',
                                minHeight: '56px',
                                height: '56px',
                                lineHeight: '1.5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: 0,
                                marginTop: 0,
                                top: 'auto',
                                bottom: 'auto',
                                left: 'auto',
                                right: 'auto',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                position: 'relative',
                                overflow: 'hidden',
                                border: 'none',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: '0 12px 30px rgba(212, 175, 55, 0.6)',
                                    background: 'var(--button-gradient-hover)'
                                },
                                '&:active': {
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 6px 20px rgba(212, 175, 55, 0.4)'
                                },
                                '&::before': {
                                    content: '""',
                                    position: 'absolute',
                                    top: 0,
                                    left: '-100%',
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                                    transition: 'left 0.6s'
                                },
                                '&:hover::before': {
                                    left: '100%'
                                }
                            }}
                        >
                            <GavelIcon sx={{ mr: 1, fontSize: '1.25rem' }} />
                            Try It Now
                        </Fab>
                        <Button
                            variant="outlined"
                            size="large"
                            onClick={() => navigate('/mycases')}
                            startIcon={<LoginIcon sx={{ fontSize: '1.25rem' }} />}
                            sx={{
                                fontWeight: 600,
                                textTransform: 'none',
                                fontSize: '1.05rem',
                                padding: '15px 28px',
                                borderRadius: '16px',
                                minHeight: '56px',
                                height: '56px',
                                lineHeight: '1.5',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: 0,
                                borderColor: 'var(--border-color)',
                                color: 'var(--text-primary)',
                                borderWidth: '2px',
                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                '&:hover': {
                                    transform: 'translateY(-2px)',
                                    borderColor: 'var(--accent-color)',
                                    borderWidth: '2px',
                                    backgroundColor: 'var(--surface-color)',
                                    boxShadow: '0 4px 12px rgba(212, 175, 55, 0.2)'
                                }
                            }}
                        >
                            Sign in
                        </Button>
                    </Box>
                </Box>
                <Paper
                    elevation={0}
                    sx={{
                        display: 'inline-block',
                        borderRadius: "8px",
                        marginBottom: "35px",
                        overflow: 'hidden',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)'
                    }}
                >
                    <video
                        width="640"
                        height="480"
                        className="demo-video"
                        src="/demo.webm"
                        preload="auto"
                        controls
                        playsInline
                        autoPlay
                        muted
                        loop
                    />
                </Paper>
            </Container>
            <Footer />
        </div>
    );
}